<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>Trích Xuất Đề Xuất</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <mat-form-field class="full" appearance="outline">
            <mat-label>Chọn khoảng thời gian</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Từ ngày">
            <input matEndDate formControlName="end" placeholder="Đến ngày">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Ngày bắt đầu không đúng</mat-error>
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Ngày kết thúc không đúng</mat-error>
          <mat-error *ngIf="range.controls.start.hasError('outOfRange')">Chỉ có thể trích xuất tối đa 3 tháng</mat-error>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Hủy bỏ</button>
      <button mat-raised-button class="agreeFwdBtn" color="warn" (click)="onSend()">Trích Xuất</button>
    </mat-dialog-actions>
</div>
